import { Col, Input, Modal, Button } from "antd";
import { useState, useEffect } from "react";
import { EnrollmentWithFormForManualItem, HandleManalPreBonuseErrorModule } from "../../../data/wallet";
import TextArea from "antd/lib/input/TextArea";
import { mailConversion, numberConversion } from "../../../actions/util";
import { translate } from "$ACTIONS/Translate";
import { Router } from "next/router";
import PromotionOneWalletModal from "../../../pages/PromotionOneWalletModal";

export default function PromotionManualPromotionApplicationForm({visible, onClose, bonus, ...props}){
    const [memberInfo, setMemberInfo] = useState(
        JSON.parse(localStorage.getItem("memberInfo")) || {}
    );
    const [Remark, setRemark] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [apiError, setApiError] = useState({});
    const [showErorModal, setShowErrorModal] = useState(false);
    useEffect(() => {
        console.log("Member Info:", memberInfo);
    }, [memberInfo?.userName]);

    useEffect(() => {
        console.log("Remark", Remark);
        if (!showErorModal) {
            setRemark(""); // Reset Remark when modal closes
        }
    }, [showErorModal]);

    useEffect(() => {
        console.log("bonusInManualPromotionApplicationForm", bonus);
        return () => {
            setRemark("");
        };
    }, [bonus?.campaignId]);

    const handleRemarkChange = (e) => {
        const { value } = e.target;
        let errorMessage = "";

        if (value?.length > 100) {
            errorMessage = translate("备注不能超过100个字符");
        } else {
            errorMessage = "";
        }
        setErrorMessage(errorMessage);
        setRemark(value.slice(0, 100));
    };

    const handleSubmitForm = async () => {
        let postData = {
            entryPeriodId:
                bonus?.campaignRow?.entryPeriod?.id || "",
            siteId: 37,
            formData: {
                formType: 2,
                remark: Remark,
                address: "",
                prize: "",
                shirtSize: "",
            },
        };
        let resp = await EnrollmentWithFormForManualItem(postData);
        console.log(
            "handleSubmitFormEnrollmentWithFormForManualItem",
            resp
        );
        if (!resp.isSuccess || !resp?.result?.isSuccess) {
            let errorType = HandleManalPreBonuseErrorModule(
                resp?.result?.errorCode
            );
            if (errorType?.showModal) {
                console.log("errorType", errorType);
                setShowErrorModal(true);
                setApiError(errorType?.config);
            } else {
                // toast.error(
                //     "Hệ thống hiện không khả dụng vì lý do nội bộ, xin vui lòng thử lại sau",
                //     {
                //         style: { minHeight: "30px", padding: "0px" },
                //         position: "top-center",
                //         autoClose: 2000,
                //         hideProgressBar: true,
                //         closeOnClick: true,
                //         pauseOnHover: false,
                //         draggable: true,
                //         progress: undefined,
                //         theme: "light",
                //         transition: Zoom,
                //         closeButton: false, // Hide the close icon
                //         icon: (
                //             <img
                //                 src="/vn/img/1wallet/00/info-yellow.svg"
                //                 alt="info-yellow"
                //             />
                //         ),
                //         className: "custom-toast-OW-project yellowInfo",
                //     }
                // );
                props?.showToastAfterFailure();
            }
        } else {
            setShowErrorModal(false);
            setApiError({});
            props?.showToastAfterSuccess();
            // Router.push("/promotions");
        }
    };

    return (
        <Modal visible={visible} footer={null} centered>
        <div className="PromotionManualPromotionApplicationForm">
            <span
                onClick={() => {
                    onClose();
                    setRemark("");
                }}
                style={{
                    position: "absolute",
                    top: "15px",
                    right: "-3px",
                    zIndex: "10",
                    cursor: "pointer",
                }}
            >
                <img
                    src="/vn/img/1wallet/00/ModalCloseIcon.svg"
                    alt="Close Icon"
                />
            </span>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        marginTop: "55px",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Đăng ký Khuyến mãi
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    BẢO HIỂM 100% CƯỢC ĐỘI VÔ ĐỊCH
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Tên Đăng Nhập
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-account"
                    defaultValue={memberInfo.userName}
                    disabled
                />
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Email
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-email"
                    defaultValue={
                        memberInfo?.isVerifiedEmail?.length > 0
                            ? mailConversion(
                                  memberInfo.isVerifiedEmail[0]
                              )
                            : "Chưa xác thực"
                    }
                    disabled
                />
                <div>
                    <div>
                        <span
                            style={{
                                color: "#666666",
                                fontSize: "12px",
                                fontWeight: "400",
                            }}
                        >
                            Nếu bạn muốn cập nhật địa chỉ email, vui
                            lòng liên hệ
                        </span>
                        <span
                            style={{
                                marginLeft: "5px",
                                color: "#00A6FF",
                                fontWeight: "400",
                                fontSize: "12px",
                                cursor: "pointer",
                            }}
                            onClick={() => global.PopUpLiveChat()}
                        >
                            Live Chat
                        </span>
                    </div>
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Số Điện Thoại
                </div>
                <Input
                    // addonBefore={"Tên Đăng Nhập"}
                    className="PromotionManualPromotionApplicationForm-phone"
                    defaultValue={
                        memberInfo?.isVerifiedPhone?.length > 0
                            ? numberConversion(
                                  memberInfo.isVerifiedPhone[0]
                              )
                            : "Chưa xác thực"
                    }
                    disabled
                />
                <div>
                    <div>
                        <span
                            style={{
                                color: "#666666",
                                fontSize: "12px",
                                fontWeight: "400",
                            }}
                        >
                            Nếu bạn muốn cập nhật địa chỉ email, vui
                            lòng liên hệ
                        </span>
                        <span
                            style={{
                                marginLeft: "5px",
                                color: "#00A6FF",
                                fontWeight: "400",
                                fontSize: "12px",
                                cursor: "pointer",
                            }}
                            onClick={() => global.PopUpLiveChat()}
                        >
                            Live Chat
                        </span>
                    </div>
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div className="ManulPromotionApplicationForm-remark">
                    <div>
                        <label
                            style={{
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#222222",
                            }}
                        >
                            {translate("备注")}
                        </label>
                    </div>
                    <TextArea
                        rows={3}
                        placeholder="Nhập Ghi chú"
                        className="PromotionManualPromotionApplicationForm-remark-textArea"
                        value={Remark}
                        style={{
                            resize: "none",
                            padding: "10px",
                            width: "100%",
                        }}
                        onChange={handleRemarkChange}
                    />
                    <p
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "100%",
                            color: "#999999",
                            fontSize: "12px",
                            fontWeight: "400",
                        }}
                    >
                        {Remark?.length}/100
                    </p>
                    {errorMessage ? (
                    <div
                        style={{
                            color: "#EB2121",
                            marginTop: "5px",
                            backgroundColor: "#FEE5E5",
                            borderRadius: "8px",
                            marginTop: "8px",
                            width: "100%",
                            textAlign: "left",
                            padding: "8px 16px",
                        }}
                    >
                        {errorMessage}
                    </div>
                ) : null}
                </div>
            </Col>
            <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                <Button
                    style={{
                        color:
                            Remark?.length === 0 ? "#999999" : "#FFFFFF",
                        backgroundColor:
                            Remark?.length === 0 ? "#E5E5E5" : "#00A6FF",
                    }}
                    className="PromotionManualPromotionApplicationForm-submit"
                    disabled={Remark?.length === 0}
                    onClick={() => {
                        // handleClose();
                        Pushgtagdata(
                            "Promotion",
                            "Submit Promotion Form",
                            "Promotion_S_Application",
                            false,
                            [
                                {
                                    customVariableKey: `Promotion_S_Application_PromoName_PrmoID`,
                                    customVariableValue: `${bonus?.promoTitle}_${bonus?.promoId}`,
                                },
                            ]
                        );
                        handleSubmitForm();
                    }}
                >
                    Gửi
                </Button>
            </Col>
            <PromotionOneWalletModal
                isVisible={showErorModal}
                config={apiError}
                onClose={() => {
                    setShowErrorModal(false);
                    setApiError({});
                }}
            />
        </div>
        </Modal>
    );
}